import {PartnerAddressModel} from './partnerAddress.model';
import {PartnerSummaryModel} from './partnerSummary.model';
import {
    MarketingChannelSummaryModel
} from '../../../../../shared/model/marketing.channel/marketingChannelSummary.model';
import {PartnerPersonSummaryModel} from "../../../modules/person/api/entity/partnerPersonSummary.model";
import {LovValueSummary} from "../../../../common/lov/lov-value/api/model/lovValueSummary.model";
export class PartnerModel {
    addresses: PartnerAddressModel[] = [];
    marketingChannels: MarketingChannelSummaryModel[] = [];
    persons: PartnerPersonSummaryModel[] = [];
    summary: PartnerSummaryModel;
    parents: PartnerParentModel[] = [];

    get mainAddress(): PartnerAddressModel {
        return this.addresses?.length > 0 ? this.addresses[0] : undefined;
    }

    get mainPerson(): PartnerPersonSummaryModel {
        return this.persons.find(value => value.id === this.summary.mainPartnerPersonId)
    }
}

export class PartnerParentModel {
    type: LovValueSummary;
    partnerId: number;
}
